import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const PrefsCtx = createContext(null);

export function PrefsProvider({ children }) {
  const [prefs, setPrefs] = useState(null);

  const reloadPrefs = useCallback(() => {
    api.get("/preferences").then(({ data }) => setPrefs(data)).catch(() => {});
  }, []);

  useEffect(() => {
    reloadPrefs();
  }, [reloadPrefs]);

  return (
    <PrefsCtx.Provider value={{ prefs, setPrefs, reloadPrefs }}>
      {children}
    </PrefsCtx.Provider>
  );
}

export const usePrefs = () => useContext(PrefsCtx) || {};
